var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bread-row" },
    [
      _vm._l(_vm.title, function (item, index) {
        return [
          _c(
            "div",
            {
              key: index,
              staticClass: "bread-row-box",
              on: {
                click: function ($event) {
                  return _vm.$emit("onClick", index)
                },
              },
            },
            [
              index !== _vm.title.length - 1
                ? _c("span", [_vm._v(_vm._s(item))])
                : _vm._e(),
              index !== _vm.title.length - 1
                ? _c("i", [_vm._v(" > ")])
                : _vm._e(),
              index === _vm.title.length - 1
                ? _c("p", [_vm._v(_vm._s(item))])
                : _vm._e(),
            ]
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }